export type Action = 
  { type: 'COMPACT_MODE' } |
  { type: 'FULL_SCREEN_CHART' } | 
  { type: 'UPDATE_INDICATORS', indicators: Indicator[] }

export const compactMode = (): Action => ({ type: 'COMPACT_MODE' })

export const fullScreenChart = (): Action => ({ type: 'FULL_SCREEN_CHART' })

export const updateIndicators = (indicators: Indicator[]): Action => ({ type: 'UPDATE_INDICATORS', indicators })